export const translations = {
  el: {
    nav: {
      home: 'Αρχική',
      about: 'Σχετικά',
      gallery: 'Γκαλερί',
      testimonials: 'Κριτικές',
      careers: 'Γίνετε Μέλος',
      contact: 'Επικοινωνία',
    },
    hero: {
      tagline: 'Η Γεύση του viral',
      subtitle: 'Viral French Fruit Desserts',
      description: 'Ανακαλύψτε τη μαγεία των trompe-l\'œil fruit desserts - γλυκά που μοιάζουν με φρούτα αλλά κρύβουν μια εκπληκτική γεύση',
      cta: 'Ανακαλύψτε τα Γλυκά μας',
      location: 'Βρείτε μας',
    },
    about: {
      title: 'Η Ιστορία της Μάγιας',
      subtitle: 'Πάθος, Δημιουργικότητα & Γεύση',
      story: 'Στον κόσμο των social media, όπου το επόμενο viral γεννιέται μερικές ώρες και το προηγούμενο χάνεται με την ταχύτητα του scroll, λίγοι προλαβαίνουν να το καταλάβουν και ακόμη λιγότεροι να το ξεπεράσουν.',
      quote: 'Η επιτυχία δεν είναι τύχη, είναι στρατηγική. Παρακολουθώ τις τάσεις αλλά κάθε επιχείρηση που θέλει να είναι μπροστά πρέπει να έχει τη δική της ταυτότητα και αυθεντικότητα.',
      quoteAuthor: '— Μάγια Παναγή',
      experience: 'Δεκαετής Εμπειρία',
      experienceDesc: 'στη ζαχαροπλαστική',
      quality: 'Ποιότητα & Αγάπη',
      qualityDesc: 'σε κάθε δημιουργία',
      viral: 'Viral Επιτυχία',
      viralDesc: 'σε όλη την Κύπρο',
      magazineAlt: 'Maya\'s Flavours στο περιοδικό',
    },
    gallery: {
      title: 'Οι Δημιουργίες μας',
      subtitle: 'Κάθε γλυκό είναι ένα έργο τέχνης',
    },
    testimonials: {
      title: 'Τι Λένε οι Πελάτες μας',
      subtitle: 'Εμπειρίες που μιλούν από μόνες τους',
    },
    contact: {
      title: 'Επικοινωνήστε μαζί μας',
      subtitle: 'Θα χαρούμε να σας εξυπηρετήσουμε',
      phone: 'Τηλέφωνο',
      location: 'Τοποθεσία',
      locationText: 'Λατσιά, Κύπρος',
      hours: 'Ώρες Λειτουργίας',
      findUs: 'Βρείτε μας στο χάρτη',
      followUs: 'Ακολουθήστε μας',
      tapToCall: 'Πατήστε για κλήση',
      monFri: 'Δευ - Παρ',
      saturday: 'Σάββατο',
      sunday: 'Κυριακή',
      closed: 'Κλειστά',
    },
    footer: {
      tagline: 'Η Γεύση του viral',
      menu: 'Μενού',
      rights: 'Με επιφύλαξη παντός δικαιώματος',
      madeWith: 'Φτιαγμένο με',
      inCyprus: 'στην Κύπρο',
      designedBy: 'Σχεδιασμός & Ανάπτυξη από',
    },
    careers: {
      title: 'Γίνετε Μέλος της Ομάδας μας',
      subtitle: 'Αναζητούμε ανθρώπους με πάθος για τη ζαχαροπλαστική τέχνη',
      applyNow: 'Κάντε Αίτηση Τώρα',
      contactToApply: 'Στείλτε το βιογραφικό σας στο',
      callUs: 'ή καλέστε μας στο',
      responsibilities: 'Αρμοδιότητες',
      idealCandidate: 'Ιδανικός Υποψήφιος',
      workingHours: 'Ωράριο Εργασίας',
      confidentiality: 'Ο επιτυχών υποψήφιος θα χρειαστεί να υπογράψει συμφωνία εμπιστευτικότητας.',
      roles: {
        kitchen: {
          title: 'Άτομο για Λάντζα',
          overview: 'Είστε η ραχοκοκαλιά του δημιουργικού μας εργαστηρίου. Ο πρωταρχικός σας ρόλος είναι να διασφαλίζετε ότι ο εξειδικευμένος εξοπλισμός ζαχαροπλαστικής μας—από τα καλούπια σιλικόνης μέχρι τα ευαίσθητα εργαλεία—είναι τέλεια απολυμασμένα και έτοιμα για χρήση.',
          responsibilities: [
            'Εξειδικευμένος Καθαρισμός: Χειροκίνητο πλύσιμο ευαίσθητων καλουπιών και εργαλείων ζαχαροπλαστικής υψηλής ποιότητας.',
            'Οργανωτική Υποστήριξη: Βοήθεια στους σεφ με τη βασική προετοιμασία υλικών.',
            'Φροντίδα Χώρου: Διατήρηση του χώρου παραγωγής, των ψυγείων, των αποθηκευτικών χώρων και των WC καθαρών και τακτοποιημένων.',
            'Διαχείριση Απορριμμάτων: Διασφάλιση υψηλών προτύπων υγιεινής και αποτελεσματική απόρριψη υλικών.',
            'Στήσιμο & Φροντίδα Καταστήματος: Διατήρηση της καθαριότητας του καταστήματος και στήσιμο της βιτρίνας και της εξωτερικής διακόσμησης.',
          ],
          ideal: [
            'Εργατικός/η και περήφανος/η για έναν πεντακάθαρο χώρο εργασίας.',
            'Κατανόηση ότι η καθαριότητα = ασφάλεια τροφίμων.',
            'Αξιόπιστος/η, ενεργητικός/η και ικανός/η να εργαστεί σε περιβάλλον με γρήγορους ρυθμούς.',
          ],
          hours: '13:00 έως 20:00',
        },
        confectioner: {
          title: 'Βοηθός Εργαστηρίου',
          overview: 'Γίνετε μέλος της ομάδας πίσω από τα πιο viral επιδόρπια της Κύπρου. Θα είστε υπεύθυνοι για τη συναρμολόγηση και το φινίρισμα των χαρακτηριστικών μας επιδορπίων φρούτων.',
          responsibilities: [
            'Τεχνική Εκτέλεση: Προετοιμασία υψηλής ποιότητας mousse, ganache και γεμίσεων φρούτων σύμφωνα με τις συνταγές μας.',
            'Καλλιτεχνικό Φινίρισμα: Εκμάθηση της τέχνης του γλασαρίσματος, του ψεκασμού και της λεπτομέρειας (trompe-l’œil).',
            'Ποιοτικός Έλεγχος: Διασφάλιση ότι κάθε κομμάτι πληροί τα αισθητικά μας πρότυπα "viral-ready".',
            'Καινοτομία: Βοήθεια στην ανάπτυξη νέων εποχιακών σχημάτων φρούτων και γεύσεων.',
          ],
          ideal: [
            'Επαγγελματική εμπειρία (Πτυχίο ή Δίπλωμα Ζαχαροπλαστικής θα θεωρηθεί επιπλέον προσόν).',
            'Εξαιρετική προσοχή στη λεπτομέρεια (νοοτροπία τελειομανή).',
            'Εμπειρία με το στρώσιμο σοκολάτας και καλούπια σιλικόνης είναι πλεονέκτημα.',
            'Πάθος για τις σύγχρονες, "Instagrammable" τάσεις.',
          ],
          hours: '10:00 έως 18:00',
        },
        customerService: {
          title: 'Εξυπηρέτηση Πελατών (Brand Ambassador)',
          overview: 'Είστε το πρώτο σημείο επαφής για τους πελάτες μας. Η δουλειά σας είναι να διηγηθείτε την ιστορία του Maya’s Flavours και να παρέχετε μια κορυφαία εμπειρία boutique.',
          responsibilities: [
            'Εξειδίκευση Προϊόντος: Γνώση των συστατικών κάθε επιδορπίου για την καθοδήγηση των πελατών.',
            'Εμπειρία Boutique: Παροχή εξαιρετικής, φιλικής εξυπηρέτησης που ταιριάζει με την premium φύση μας.',
            'Διαχείριση Παραγγελιών: Χειρισμός πωλήσεων και προπαραγγελιών για εκδηλώσεις.',
            'Visual Merchandising: Διασφάλιση ότι οι προθήκες φαίνονται πάντα όμορφες.',
          ],
          ideal: [
            'Εξωστρεφής, ευγενικός/η και με καλή χρήση του λόγου (Ελληνικά & Αγγλικά).',
            'Ένας "foodie" που μπορεί να περιγράψει τις γεύσεις με πάθος.',
            'Εμπειρία στο λιανικό εμπόριο υψηλής ποιότητας ή στη φιλοξενία.',
            'Άνεση με τα μέσα κοινωνικής δικτύωσης.',
          ],
        },
      },
    },
  },
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      gallery: 'Gallery',
      testimonials: 'Reviews',
      careers: 'Join Us',
      contact: 'Contact',
    },
    hero: {
      tagline: 'The Taste of Viral',
      subtitle: 'Viral French Fruit Desserts',
      description: 'Discover the magic of trompe-l\'œil fruit desserts - sweets that look like fruits but hide an amazing taste',
      cta: 'Discover Our Sweets',
      location: 'Find Us',
    },
    about: {
      title: 'Maya\'s Story',
      subtitle: 'Passion, Creativity & Taste',
      story: 'In the world of social media, where the next viral is born in a few hours and the previous one is lost at the speed of scroll, few manage to understand it and even fewer to surpass it.',
      quote: 'Success is not luck, it\'s strategy. I follow trends but every business that wants to be ahead must have its own identity and authenticity.',
      quoteAuthor: '— Maya Panayi',
      experience: 'Decade of Experience',
      experienceDesc: 'in pastry making',
      quality: 'Quality & Love',
      qualityDesc: 'in every creation',
      viral: 'Viral Success',
      viralDesc: 'across Cyprus',
      magazineAlt: 'Maya\'s Flavours in magazine',
    },
    gallery: {
      title: 'Our Creations',
      subtitle: 'Every sweet is a work of art',
    },
    testimonials: {
      title: 'What Our Customers Say',
      subtitle: 'Experiences that speak for themselves',
    },
    contact: {
      title: 'Contact Us',
      subtitle: 'We\'d love to serve you',
      phone: 'Phone',
      location: 'Location',
      locationText: 'Latsia, Cyprus',
      hours: 'Opening Hours',
      findUs: 'Find us on the map',
      followUs: 'Follow us',
      tapToCall: 'Tap to call',
      monFri: 'Mon - Fri',
      saturday: 'Saturday',
      sunday: 'Sunday',
      closed: 'Closed',
    },
    footer: {
      tagline: 'The Taste of Viral',
      menu: 'Menu',
      rights: 'All rights reserved',
      madeWith: 'Made with',
      inCyprus: 'in Cyprus',
      designedBy: 'Designed & Developed by',
    },
    careers: {
      title: 'Join Our Team',
      subtitle: 'We are looking for people with a passion for the art of pastry',
      applyNow: 'Apply Now',
      contactToApply: 'Send your CV to',
      callUs: 'or call us at',
      responsibilities: 'Responsibilities',
      idealCandidate: 'Ideal Candidate',
      workingHours: 'Working Hours',
      confidentiality: 'The successful candidate will need to sign a confidentiality agreement.',
      roles: {
        kitchen: {
          title: 'Kitchen Dishwasher',
          overview: 'You are the backbone of our creative lab. Your primary role is to ensure that our specialized pastry equipment—from silicone fruit molds to delicate tools—is perfectly sanitized and ready for use.',
          responsibilities: [
            'Specialized Cleaning: Hand-washing delicate molds and high-end pastry tools.',
            'Organizational Support: Assisting the chefs with basic ingredient preparation.',
            'Facility Care: Keeping the production floor, fridges, storage areas and WC cleaned and tidy.',
            'Waste Management: Ensuring high standards of hygiene and efficient disposal of materials.',
            'Shop Setup and Care: Keep the shop clean and setup the shop front and outside decoration.',
          ],
          ideal: [
            'Hardworking and takes pride in a "spotless" workspace.',
            'Understand that in a pastry lab, cleanliness = food safety.',
            'Reliable, energetic, and able to work in a fast-paced environment.',
          ],
          hours: '13:00 to 20:00',
        },
        confectioner: {
          title: 'Confectionery Assistant',
          overview: 'Join the team behind Cyprus’s most viral desserts. You will be responsible for the assembly and finishing of our signature fruit desserts.',
          responsibilities: [
            'Technical Execution: Preparing high-quality mousses, ganaches, and fruit inserts according to Maya’s signature recipes.',
            'Artistic Finishing: Mastering the art of glazing, spraying, and detailing desserts (trompe-l’œil).',
            'Quality Control: Ensuring every single piece meets our "viral-ready" aesthetic standards.',
            'Innovation: Assisting in the development of new seasonal "fruit" shapes and flavors.',
          ],
          ideal: [
            'Professional experience (a Degree or Diploma in Pastry Arts will be considered an advantage)',
            'Extreme attention to detail (a perfectionist’s mindset).',
            'Experience with chocolate tempering and silicone mold work is a plus.',
            'Passion for modern, "Instagrammable" pastry trends.',
          ],
          hours: '10:00 to 18:00',
        },
        customerService: {
          title: 'Customer Service & Brand Ambassador',
          overview: 'You are the first point of contact for our customers. Your job is to tell the story of Maya’s Flavours and provide a premium boutique experience.',
          responsibilities: [
            'Product Expertise: Knowing exactly what is inside every fruit dessert to guide customer choices.',
            'Boutique Experience: Providing a high-end, friendly service that matches our premium nature.',
            'Order Management: Handling in-store sales and managing pre-orders for events.',
            'Visual Merchandising: Ensuring the display cases are always looking beautiful.',
          ],
          ideal: [
            'Outgoing, polite, and well-spoken (Greek & English).',
            'A "foodie" who can describe flavors with passion.',
            'Experience in high-end retail or hospitality.',
            'Comfortable with social media.',
          ],
        },
      },
    },
  },
};
